import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import axios from 'axios'

import { useConfig } from '@peracto/peracto-config'

import * as S from './styled'

const File = ({
    label = '',
    className,
    showThumbnail = false,
    value,
    onChange,
    isInline = true,
    ...props
}) => {
    const config = useConfig()
    const API_URL = config.get('api')
    const { uploads } = config.get('features', {})

    const inputFile = useRef(null)

    const token = window.localStorage.getItem('token')

    const acceptedFiles = ['png', 'jpg', 'jpeg']

    const getAssetUrl = async file => {
        if (!acceptedFiles) {
            toast.error('Invalid file type, please upload a .png, .jpg, or .jpeg file')
        }
        const extension = file?.name.split('.')[1]

        if (acceptedFiles.filter(file => file === extension)) {
            const payload = {
                type: 'content',
                filename: file?.name.split('.')[0],
                extension: extension,
            }

            try {
                const res = await axios.post(`${API_URL}/uploads`, payload, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                })

                try {
                    await axios.put(res.data.assetUrl, file, {
                        headers: { 'Content-Type': file.type || 'application/octet-stream' },
                    })

                    onChange(`${process.env.REACT_APP_ASSETS_URL}/images/content/${file?.name}`)
                } catch (e) {
                    console.error(e)
                    toast.error(
                        e?.error?.body?.hasOwnProperty('hydra:description')
                            ? e.error.body['hydra:description']
                            : 'Whoops, there was a problem...'
                    )
                }
            } catch (e) {
                console.error(e)
                toast.error(
                    e?.error?.body?.hasOwnProperty('hydra:description')
                        ? e.error.body['hydra:description']
                        : 'Whoops, there was a problem...'
                )
            }
        } else {
            console.error('Invalid file type')
            toast.error('Invalid file type')
            return
        }
    }

    return (
        <div
            className="form-group"
            data-testid={`${label.toLowerCase().replaceAll(' ', '-')}-section`}
        >
            {label && <label className="!mb-1">{label}</label>}
            <div className="input-group">
                {showThumbnail && value?.length > 0 && (
                    <div className="!flex !w-full">
                        <S.ImageThumbnail src={value} />
                    </div>
                )}

                <div className={`!flex !w-full ${!isInline ? '!flex-col' : ''}`}>
                    <input
                        type="text"
                        className="form-control"
                        onChange={e => onChange(e.target.value)}
                        value={value || ''}
                        {...props}
                    />
                    {uploads?.CKEditorBypass && (
                        <>
                            <input
                                type="file"
                                id="file"
                                ref={inputFile}
                                onChange={async event => {
                                    await getAssetUrl(event.target.files[0])
                                }}
                                style={{ display: 'none' }}
                            />

                            <button
                                className={`btn btn-primary !whitespace-nowrap ${
                                    isInline ? '!ml-2' : '!mt-2'
                                }`}
                                data-testid="upload-button"
                                onClick={e => {
                                    e.preventDefault()
                                    inputFile.current.click()
                                }}
                            >
                                Upload
                            </button>
                        </>
                    )}

                    <button
                        className={`btn btn-secondary !whitespace-nowrap ${
                            isInline ? '!ml-2' : '!mt-2'
                        }`}
                        data-testid="browse-button"
                        onClick={e => {
                            e.preventDefault()
                            if (window?.CKFinder) {
                                window.CKFinder.modal({
                                    chooseFiles: true,
                                    displayFoldersPanel: false,
                                    removeModules: 'Maximize,EditImage',
                                    pass: 'token',
                                    token: token,
                                    width: 800,
                                    height: 600,
                                    onInit: function(finder) {
                                        finder.on('files:choose', function(evt) {
                                            var file = evt.data.files.first()
                                            if (typeof onChange === 'function') {
                                                onChange(file.getUrl())
                                            }
                                        })

                                        finder.on('file:choose:resizedImage', e => {
                                            if (typeof onChange === 'function') {
                                                onChange(e.data.resizedUrl)
                                            }
                                        })
                                    },
                                })

                                return false
                            }
                        }}
                    >
                        Browse
                    </button>
                </div>
            </div>
        </div>
    )
}

File.displayName = 'File'

File.propTypes = {
    label: PropTypes.string,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    placeholder: PropTypes.string,
    className: PropTypes.string,
    showWhen: PropTypes.string,
}

export default File
